import React from 'react';

interface ImageFullscreenProps {
  url: string;
  webp?: string;
  imageAlt?: string;
}

const ImageFullscreen = ({ url, webp, imageAlt }: ImageFullscreenProps) => (
  <picture>
    {webp && <source type="image/webp" srcSet={webp} />}
    <img src={url} alt={imageAlt} className="lightbox-image l-full" />
  </picture>
);

export default ImageFullscreen;
